module.exports = __webpack_public_path__ + "img/avatar-s-222.65561634.jpg";